import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=586c442f&scoped=true"
import script from "./sales.vue?vue&type=script&lang=ts"
export * from "./sales.vue?vue&type=script&lang=ts"
import style0 from "./sales.vue?vue&type=style&index=0&id=586c442f&prod&lang=less&scoped=true"
import style1 from "./sales.vue?vue&type=style&index=1&id=586c442f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c442f",
  null
  
)

export default component.exports